/** Composante Scrolly de Timtools */
export default class Scrolly {
  constructor(element) {
    this.element = element;

    //Les réglages par défaut de Scrolly
    this.options = {
      rootMargin: '0px 0px 0px 0px',
    };
    console.log('dfgsgdfg');

    this.init();
  }

  /**Fonction d'initialisation**/
  init() {
    //ajoute un observer qui observe l'intersection du viewport et d'un élément html
    this.observer = new IntersectionObserver(
      this.watch.bind(this),
      this.options
    );

    const items = this.element.querySelectorAll('[data-scrolly]');

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      this.observer.observe(item);
    }
  }

  //fonction qui permet de voir quel sont les éléments qui sont entrés en intersection avec le viewport et leur rajoute ou enleve la classe "is-active"
  watch(entries) {
    for (let i = 0; i < entries.length; i++) {
      const entry = entries[i];
      const target = entry.target;

      if (entry.isIntersecting) {
        target.classList.add('is-active');

        //vérifie la valeur du data-component "execute_once" et si il est true, arrête de regarder les élements qui ont déjà été regardés.
        if (this.element.dataset.execute_once == 'true') {
          this.observer.unobserve(target);
        }
      } else {
        target.classList.remove('is-active');
      }
    }
  }
}
